import { forwardRef } from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../index";

const badgeVariants = cva("font-medium px-3 py-1.5 inline-flex items-center rounded-[50px] text-sm", {
  variants: {
    status: {
      primary: "bg-primary-blue text-primary-white",
      success: "bg-primary-green text-primary-white",
      warning: "bg-primary-warning text-primary-dark-blue",
      error: "bg-primary-red text-primary-white",
    },
  },
  defaultVariants: {
    status: "primary",
  },
});

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({ status, className, ...props }, forwardedRef) => (
  <span {...props} ref={forwardedRef} className={cn(badgeVariants({ status, className }))} />
));

Badge.displayName = "Badge";

export default Badge;
export { Badge, badgeVariants };
